import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { useNavigate } from 'react-router-dom';

type TimeSiteProps = {
  page: string;
};
const TimeSiteSwitch: React.FC<TimeSiteProps> = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <ButtonGroup aria-label='Basic button group' sx={{ mb: '20px' }}>
        <Button
          onClick={() => navigate('/master/time')}
          variant={props.page === 'mastertime' ? 'contained' : 'outlined'}
          sx={{ fontSize: '14px', fontWeight: 500 }}
        >
          予約可能時間設定
        </Button>
        <Button
          onClick={() => navigate('/setting/site')}
          variant={props.page === 'settingsite' ? 'contained' : 'outlined'}
          sx={{ fontSize: '14px', fontWeight: 500 }}
        >
          予約機能設定
        </Button>
      </ButtonGroup>
    </>
  );
};

export default TimeSiteSwitch;
